<template>
  <app-layout title="School">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        学校管理
      </h2>
    </template>
    <div class="py-8">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="flex flex-row-reverse items-center">
          <button
            class="mr-2 mb-4 px-8 py-2 rounded bg-blue-600 text-white max-w-max shadow-sm hover:shadow-lg"
            @click.prevent="onClickedUserRegistrationTasksButton">
            登録タスク一覧
          </button>
          <button
            class="mr-2 mb-4 px-8 py-2 rounded bg-green-500 text-white max-w-max shadow-sm hover:shadow-lg"
            @click.prevent="onClickedUserRegistrationButton">
            ユーザの追加
          </button>
        </div>
        <div>
          <ul class="flex">
            <li
              :class="showTabDisplay === 0 ? 'bg-white' : 'bg-gray-300'"
              class="cursor-pointer p-5 mx-2 rounded-t-xl"
              @click="changeTab(0)">
              学校一覧
            </li>
            <li
              :class="showTabDisplay === 1 ? 'bg-white' : 'bg-gray-300'"
              class="cursor-pointer p-5 mx-2 rounded-t-xl"
              @click="changeTab(1)">
              マークシート情報読み込み
            </li>
            <li
              :class="showTabDisplay === 2 ? 'bg-white' : 'bg-gray-300'"
              class="cursor-pointer p-5 mx-2 rounded-t-xl"
              @click="changeTab(2)">
              アプリサブスク管理
            </li>
          </ul>
        </div>
        <div class="p-5 bg-white overflow-hidden shadow-xl sm:rounded-lg">
          <div>
            <ul>
              <li v-if="showTabDisplay === 0">
                <school-list
                  :schools="schools"
                  :sort="sort"
                  :order="order" />
              </li>
              <li v-if="showTabDisplay === 1">
                <mark-sheet-reading-form
                  :schools="schools"
                  :examinations="examinations"
                  :examination-types="examinationTypes"
                  :selected-school-id="selectedSchoolId"
                  :selected-examination-id="selectedExaminationId"
                  :selected-examination-type="selectedExaminationType"
                  :is-selected-linked-student-data-only="isSelectedLinkedStudentDataOnly"
                  :show-tab-display="showTabDisplay"
                  :not-existent-users-data="notExistentUsersData"
                  :answer-registered-users-data="answerRegisteredUsersData"
                  :same-id-users-data="sameIdUsersData"
                  :not-student-users-data="notStudentUsersData"
                  :csv-labels="csvLabels"
                  :registered-user-count="registeredUserCount" />
              </li>
              <li v-if="showTabDisplay === 2">
                <app-subscribe-management
                  :schools="schools"
                  :school-id="schoolId"
                  :school-years="schoolYears"
                  :students="students"
                  :sort="sort"
                  :order="order"
                  :grade="grade"
                  :subscription-status="subscriptionStatus" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { onMounted, defineProps, ref } from 'vue'
import SchoolList from './Partials/SchoolList'
import MarkSheetReadingForm from './Partials/MarkSheetReadingForm'
import AppSubscribeManagement from './Partials/AppSubscribeManagement'
import AppLayout from '@/Layouts/AppLayout'

const props = defineProps({
  schools: {
    type: Object,
    default: () => ({}),
  },
  examinations: {
    type: Array,
    default: () => [],
  },
  examinationTypes: {
    type: Object,
    default: () => ({}),
  },
  selectedSchoolId: {
    type: Number,
    default: 0,
  },
  selectedExaminationId: {
    type: Number,
    default: 0,
  },
  selectedExaminationType: {
    type: Number,
    default: 0,
  },
  isSelectedLinkedStudentDataOnly: {
    type: Boolean,
    default: true,
  },
  showTabDisplayNum: {
    type: Number,
    default: 0,
  },
  sort: {
    type: String,
    default: 'id',
  },
  order: {
    type: String,
    default: 'asc',
  },
  notExistentUsersData: {
    type: Object,
    default: () => ({}),
  },
  answerRegisteredUsersData: {
    type: Object,
    default: () => ({}),
  },
  sameIdUsersData: {
    type: Object,
    default: () => ({}),
  },
  notStudentUsersData: {
    type: Object,
    default: () => ({}),
  },
  csvLabels: {
    type: Array,
    default: () => [],
  },
  registeredUserCount: {
    type: Number,
    default: 0,
  },
  schoolId: {
    type: Number,
    default: null,
  },
  schoolYears: {
    type: Number,
    default: null,
  },
  students: {
    type: Object,
    default: () => ({}),
  },
  grade: {
    type: Number,
    default: 0,
  },
  subscriptionStatus: {
    type: Number,
    default: 0,
  }
})
const showTabDisplay = ref(props.showTabDisplayNum) ?? 0
const changeTab = (num) => {
  showTabDisplay.value = num
}

onMounted(() => {
  showTabDisplay.value = props.showTabDisplayNum
})

const onClickedUserRegistrationButton = () => {
  Inertia.get(route('usersRegistration'))
}

const onClickedUserRegistrationTasksButton = () => {
  Inertia.get(route('usersRegistration.task'))
}
</script>
